import type {
  AssetConditionRatingFieldValue,
  AssetConditionRatingMutateValue,
} from "./asset-condition-rating-field.type";
import type { AssetEntity } from "@/entities/asset";

import { CONDITION_RATING_NOT_RATED } from "@/entities/referential/referential-condition-ratings";

export const getAssetConditionRatingFieldValue = (
  asset?: AssetEntity
): AssetConditionRatingFieldValue => {
  return asset?.condition_rating ?? CONDITION_RATING_NOT_RATED;
};

export const getAssetConditionRatingMutateValue = (
  value?: AssetConditionRatingFieldValue | AssetConditionRatingMutateValue
): AssetConditionRatingMutateValue => {
  return value === CONDITION_RATING_NOT_RATED ? null : (value ?? null);
};
